import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';

export interface PhysicalCountMetricInfoButtonProps {
  tooltip: string;
  label: string;
}

const PhysicalCountMetricInfoButton: React.FC<PhysicalCountMetricInfoButtonProps> = ({
  tooltip,
  label,
}) => (
  <Tooltip title={tooltip} arrow placement="top" enterTouchDelay={0}>
    <IconButton
      size="small"
      aria-label={`Información: ${label}`}
      sx={{
        position: 'absolute',
        right: 4,
        bottom: 4,
        width: 18,
        height: 18,
        p: 0,
        minWidth: 0,
        color: 'text.secondary',
        bgcolor: 'transparent',
        borderRadius: '50%',
        boxShadow: 'none',
        opacity: 0.75,
        '&:hover': {
          bgcolor: 'transparent',
          boxShadow: 'none',
          opacity: 1,
        },
        '&:focus-visible': {
          boxShadow: 'none',
        },
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
    </IconButton>
  </Tooltip>
);

export default PhysicalCountMetricInfoButton;
